module.exports = __webpack_public_path__ + "media/app/img/color-pencils-3637968cd19827452607fcc67fc9e8e0.png";